<template>
  <div :class="['main', 'layout-box']" @click="showLeftMessage = false">
    <header-general type="logged"
                    v-if="!noHeader"
                    :new-message="newMessage"
                    :new-upload="newUpload"
                    :new-feedback="newFeedback"
                    :refresh-index="refreshHeaderIndex"
                    :user-info="userInfo"
                    :page-title="previewName"
                    :is-white="headerWhite"
                    :no-logo="noLogo"
                    :capacity="capacity"
                    :showAnimate="showAnimate"
                    @queryStorage="getWorkspaceList"
                    @clickHandle="headerClickFun">
    </header-general>
    <div class="content-box flex flex-row"
         v-loading="loadingInStore.contentBox"
         :style="{height: noHeader ? '100%' : contentHeight + 'px'}">
      <menu-left v-show="hasLeftMenu" @foldHandle="foldMenu" :contentHeight="contentHeight"></menu-left>
      <div v-loading="loadingInStore.content"
           class="content flex-1 prj_scroll-ctx right-content"
           :class="{'page-home': $route.path === '/workbench/index', relative: /^\/(database\/[^data\/record\/.*])|(space\/database).*/.test($route.path)}">
        <router-view></router-view>
        <!--微服务挂载节点-->
        <div id="sub-app-viewport" class="width-full height-full relative" v-show="isMicroPage"></div>
      </div>
    </div>
    <div class="menu-tips" id="menu-tips" v-if="showMenuTips">
      <div class="relative width-full height-full">
        <span class="triangle"></span>
        <div class="rectangle">
          <i class="r2-icon-Click float_left"></i>
          <p>将已完结项目上传到备案项目库，可解析形成工程数据供企业后续使用</p>
          <i class="r2-icon-nav_close menu-tips-i" @click.stop="setTips('RECORDTIPS')"></i>
        </div>
      </div>
    </div>
    <!-- 不是中间页、跳板页才有以下内容 -->
    <template v-if="!boardPage">
      <left-message :showLeftMessage="showLeftMessage" @showAllNotice="showAllNotice"  @closeMessage="closeAllNotice"></left-message>
    </template>
    <main-message v-if="showMainMessage" @closeMessage="closeAllNotice"></main-message>
    <!--消息弹框-->
    <div :class="['notify', {'animate': showAnimate}]">
      <notifications :width="notifyWidth" group="foo" :max="2" position="top right" classes="my-style">
        <template slot="body" slot-scope="props">
          <!--@click="props.close"-->
          <div class="my-style" @click="handleCloseMessage(props)">
            <div class="icon-box">
              <div class="notice_item_img bg-green" v-if="props.item.type === 1">
                <i class="r2-icon-av_featured_play_list color-green"></i>
              </div>
              <div class="notice_item_img bg-orange" v-else-if="props.item.type === 2">
                <i class="r2-icon-cmc_chat color-orange" ></i>
              </div>
              <div class="notice_item_img bg-blue" v-else-if="props.item.type === 3">
                <i class="r2-icon-social_share color-blue"></i>
              </div>
              <div class="notice_item_img bg-purple" v-else-if="props.item.type === 5">
                <i class="r2-icon-social_group color-purple"></i>
              </div>
              <div class="notice_item_img bg-blue" v-else-if="props.item.type === 6">
                <i class="r2-icon-device_widgets color-blue"></i>
              </div>


              <div class="notice_item_img bg-purple" v-else-if="[4, 5, 6, 7].includes(props.item.type)">
                <i class="r2-icon-cmc_business color-purple"></i>
              </div>
            </div>
            <div class="content-box">
              <a class="notification-title">
                {{props.item.title}}
              </a>
              <!--<a class="close" @click="props.close">-->
                <!--<i class="fa fa-fw fa-close"></i>-->
              <!--</a>-->
              <div class="notification-content" v-html="props.item.text"></div>
            </div>
          </div>
        </template>
      </notifications>
    </div>
    <w-dialog @close="showImportDialog = false" :show="showImportDialog" title="导入个人账号资料" :wallStyle="{zIndex: 2001}" :boxStyle="{ width: '410px', zIndex: 2001 }" :bodyStyle="{padding: '0px'}">
      <import-personal-account @close="showImportDialog = false" v-if="showImportDialog"></import-personal-account>
    </w-dialog>
    <!-- 密保手机 -->
    <bind-mobile-phone :show="showBindMobilePhone" @postPasswordMobile="postPasswordMobile"></bind-mobile-phone>
    <!--UGC合规检测-->
    <complain :visible="showComplain" :fileInfo="complainfileInfo" @close="closeComplainDialog"></complain>
    <complain-success :visible="showComplainSuccess" @close="showComplainSuccess = false"></complain-success>
  </div>
</template>
<style lang="less" type="text/less">
  @import "./index.less";
  .width-394{
    width: 394px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(33, 37, 48, 0.8)!important;
    line-height: 22px;
  }
  .notify {
    .vue-notification-group {
      top: 60px !important;
    }

    &.animate {
      .vue-notification-group {
        top: 20px !important;
        transform-origin: right top;
        animation: scaleTo 0.5s;
        -webkit-animation: scaleTo 0.5s;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
      }
    }
  }

  .my-style {
    animation: fadeInRight 0.5s;
    -webkit-animation: fadeInRight 0.5s;
    /*display: flex;*/
    width: 300px;
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    // position: fixed;
    background-color: #fff;
    box-shadow:0px 2px 16px 0px rgba(33,37,48,0.2);
    transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s;
    overflow: hidden;
    margin: 10px;

    .icon-box {
      width: 28px;
      float: left;
      .notice_item_img {
        width: 28px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        border-radius: 50%;
        &.bg-blue {
          background-color: rgba(32,121,250,0.1);
        }
        &.bg-green {
          background-color: rgba(0,196,97,0.1);
        }
        &.bg-orange {
          background-color: rgba(248,149,2,0.1);
        }
        &.bg-purple {
          background-color: rgba(158,70,204,0.1);
        }
        &.read {
          opacity: 0.6;
        }
        i {
          display: inline-block;
          font-size: 16px;
        }
      }
    }

    .content-box {
      width: calc(100% - 42px);
      margin-left: 42px;

    }
    .notification-title {
      font-size: 14px;
      margin: 0;
      font-weight: 400;
      color:rgba(33,37,48,1);
      line-height: 22px;
      word-break: break-all;

      strong {
        color: #1f6ece !important;
      }
    }

    .notification-content {
      font-size: 14px;
      line-height: 21px;
      margin: 6px 0 0;
      color: #606266;
      text-align: justify;

      span {
        width: 35px;
        float: left;
      }

      strong {
        color: #1f6ece;
        word-break: break-word; /* 文本行的任意字内断开 */
        word-wrap: break-word; /* IE */
        white-space: -hp-pre-wrap; /* HP printers */
        white-space: -o-pre-wrap; /* Opera 7 */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -moz-pre-wrap; /* Mozilla */
        white-space: pre; /* CSS2 */
        white-space: pre-wrap; /* CSS 2.1 */
        white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
      }
    }
  }

  /*从右到左进入*/
  @keyframes fadeInRight {
    from {
      opacity: 0;
      -webkit-transform: translate(300px, 0);
      transform: stranslate(300px, 0);
    }
    to {
      opacity: 1;
      -webkit-transform: translate(0px, 0);
      transform: stranslate(0px, 0);
    }
  }
</style>
<style lang="less" type="text/less" scoped>
  .layout-box {
    padding-top: 0;
    width: 100%;
    min-width: 1280px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    .menu-tips {
      position: absolute;
      left: 20px;
      top: 150px;
      z-index: 2001;
      animation: dialog-fade-in ease-in-out .8s;
      transition: top .6s ease;
      width: 350px;
      height: 103px;
      cursor: default;
      .triangle {
        position: absolute;
        top: -20px;
        left: 38px;
        content: '';
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #2079fa;
        border-left: 10px solid transparent;
      }
      .rectangle {
        height: 93px;
        padding: 25px 20px 20px 20px;
        box-sizing: border-box;
        line-height: 24px;
        background: #2079fa;
        border-radius: 4px;
        box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.15);
        i {
          font-size: 28px;
          color: #ffffff;
          &.menu-tips-i {
            position: absolute;
            font-size: 20px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            right: 8px;
            top: 8px;
            color: rgba(255, 255, 255, 0.55);
            cursor: pointer;
            &:hover {
              color: #ffffff;
            }
          }
        }
        p {
          margin-left: 39px;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .content-box {
    height: calc(100% - 56px);
    /*position: relative;*/
  }

  .content {
    background: rgb(255, 255, 255);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    /*border-left: 1px solid #DDDFE2;*/
    &.page-home {
      width: 100%;
      height: 100%;
      // background: url("~@/assets/images/home_bg.jpg") no-repeat center center;
      background: url("~@/assets/images/home_bg.png") no-repeat center center;
      background-size: cover;
    }
  }
</style>
<script>
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import {MainMessage, LeftMessage, MenuLeft, ImportPersonalAccount, BindMobilePhone} from './components'
import windowResizeMixin from '@/assets/mixins/window-resize'
import previewButtonsMixin from '@/assets/mixins/preview-buttons'
import {getCookie, setCookie, delCookie, previewShareGtj} from '@/assets/utils/CommonUtil'
import {getParams, isEmptyObject} from '@/assets/utils'
import {mapState, mapMutations} from 'vuex'
import Bus from '@/assets/utils/bus'
import {on} from '@zjy/zjy-ui/lib/utils/dom'
import websocketMixin from '@/assets/mixins/websocket'
import api from 'service'
import spaceService from '@/assets/service/space'
import MessageService from '@/assets/service/message'
import permissionService from '@/assets/service/permission'
import Complain from '@/components/complain/Index'
import ComplainSuccess from '@/components/complain/Success'

export default {
  name: 'Layout',
  mixins: [windowResizeMixin, previewButtonsMixin, websocketMixin],
  data () {
    return {
      menu: {
        fold: false
      },
      contentHeight: 0,
      noUsablePackageImg: require('//static/images/non-member.png'),
      capacity: {
        // 空间容量
        company: {
          // 企业
          total: 0,
          used: 0
        },
        personal: {
          // 个人
          total: 0,
          used: 0,
          staffUsed: 0
        }
      },
      refreshHeaderIndex: 0, // 实时获取了 空间使用情况时 刷新下 header 空间使用情况 进度条
      previewName: '', // 预览文件 文件名
      privacyShow: true, // 隐私协议弹出层是否显示
      showLeftMessage: false, // 页面右侧显示 消息列表
      showMainMessage: false, // 显示所有消息弹窗
      newFeedback: false, // 是否有新的反馈消息
      newMessage: false, // 是否有新的未读消息
      newUpload: 0, // 历史上传 有新动态
      mainPage: this.$route.path.indexOf('/share/') !== 0,
      showAnimate: false,
      notifyWidth: 330,
      showImportDialog: false,
      showBindMobilePhone: false, // 是否绑定密保手机
      showComplain: false, // 显示合规检测
      complainfileInfo: {}, // 合规检测文件信息
      showComplainSuccess: false,
      showMenuTips: false, // 是否显示菜单引导提示
      apiReadStatus: false
    }
  },
  computed: {
    ...mapState({
      hideLeftMenus: state => state.menus.hideLeftMenus,
      workspace: state => state.space.workspace,
      userInfoReady: state => state.user.userInfoReady,
      userData: state => state.user.user,
      permission: state => state.user.permission,
      toLoginAsAdmin: state => state.user.toLoginAsAdmin,
      sidebarData: state => state.sidebarData.user,
      feedback: state => state.sidebarData.feedback,
      uploadMessage: state => state.upload.message,
      active: state => state.sidebarData.active,
      sessionAlertIndex: state => state.config.sessionAlertIndex,
      sessionAlertShow: state => state.config.sessionAlertShow,
      noUsablePackageAlertShow: state => state.config.noUsablePackageAlertShow,
      triggerInitPageIndex: state => state.config.triggerInitPageIndex,
      menuList: state => state.menus.menuList,
      hideNavBar: state => state.menus.hideNavBar,
      isMicro: state => state.menus.isMicro
    }),
    // 1. 是否是中间页、跳板页
    boardPage () {
      return /^\/(board|share|home)/.test(this.$route.path)
    },
    // 1.1 header 是白底的
    headerWhite () {
      let res = false
      if (/^\/applications\/iframe/.test(this.$route.path)) {
        res = true
      }
      return res
    },
    // 1.2 header 里不显示 logo
    noLogo () {
      let res = false
      if (/^\/applications\/iframe/.test(this.$route.path)) {
        res = true
      }
      return res
    },
    // 1.3 header 不显示
    noHeader () {
      let show = false
      if ((/^\/applications\/iframe/.test(this.$route.path) && this.previewName === '计价依据库') || this.$route.query.hideNavBar === 'true' || this.hideNavBar) {
        show = true
      }
      return show
    },
    // 登录用户信息
    userInfo () {
      let info = {
        storage: this.capacity.personal.total,
        storage_used: this.capacity.personal.used // 已使用空间大小
        // portrait: 'https://account.glodon.com/avatar/show/6016508908750189496/32', // 员工头像
        // userType: 3, // 1: 非云授权管理员账号; 2: 个人账号; 3: 员工账号;
        // userName: 'zhangxf001@003' // 员工名称
      }
      if (this.user && this.user.gldUserId) {
        info.portrait =
            'https://account.glodon.com/avatar/show/' +
            this.user.gldUserId +
            '/32'
      }
      Object.assign(info, this.user || {})
      return info
    },
    isMicroPage () {
      return /^\/cfmcc\/.*/.test(this.$route.path)
    },
    hasLeftMenu () {
      let has = true
      const path = this.$route.path
      const query = this.$route.query
      if (this.boardPage ||
        this.isPreviewPage ||
        this.isMicroPage ||
        this.hideLeftMenus ||
        (query.hideLeftMenus && query.hideLeftMenus === 'true') ||
        (query.linkUrl && query.linkUrl.includes('hideLeftMenus=true')) ||
        /^\/workbench/.test(path) ||
        (/^\/project\//.test(path) && [1, 5].includes(this.user.role)) ||
        /^\/database\/data\/record\//.test(path)) {
        has = false
      }
      return has
    }
  },
  created () {
  },
  mounted () {
    this.getPermission()
    this.getTenantInfo()
    this.initPage()
    Bus.$on('preview', ({item, icon, type, options}) => {
      this.filePreview(item, icon, type, options)
    })
    // 菜单产品引导提示
    Bus.$on('leftMenuTips', async (show = true) => {
      if (this.user.role === 2) {
        if (/^\/project\/.*/.test(this.$route.path)) {
          // 请求接口，获取是否是总负责人第一次登录系统访问项目库
          const readStatus = await this.getTips('RECORDTIPS')
          this.apiReadStatus = true
          if (readStatus) {
            this.closeTips(false)
          } else {
            // show = false 代表左侧菜单收缩
            if (['/project/joined/list', '/project/database', '/project/all/list'].includes(this.$route.path) && show) {
              const el = document.getElementById('recordProject')
              if (el) {
                this.showMenuTips = true
                this.$nextTick(() => {
                  const {top} = el.getBoundingClientRect()
                  const target = document.getElementById('menu-tips')
                  target.style.top = (top + 40) + 'px'
                })
              }
            } else {
              this.closeTips()
            }
          }
        } else {
          this.closeTips(this.apiReadStatus)
        }
      }
    })
  },
  beforeDestroy () {
    this.refreshHotpoint()
    this.checkSession()
  },
  methods: {
    // 获取引导提示信息
    async getTips (type) {
      try {
        const {code, data = {}} = await api.common.getTips()
        if (code === 200) {
          return !!data[type]
        }
        return true
      } catch (e) {
        return true
      }
    },
    // 更新引导提示信息
    setTips (type) {
      api.common.setTips(type).then(res => {
        if (res.code === 200) {
          this.showMenuTips = false
        }
      })
    },
    // 关闭引导提示
    closeTips (needRequest = true) {
      this.showMenuTips = false
      needRequest && this.setTips('RECORDTIPS')
    },
    // 收到 websocket 推送的消息时
    receivedMessage ({authorAccount = '', fileName = '', hasMarkup = false, messageType = 3, content = '', senderUserName = '', url = ''}) {
      // 导入个人账号成功，且当前路由地址未员工空间时，刷新员工空间列表
      if (messageType === 4 && url && url.indexOf('#/space/files/list') > -1 && window.location.hash.indexOf('#/space/files/list') > -1) {
        Bus.$emit('refreshList')
      }
      // {"senderUserName":"ker02@003","recevierGldUserIdList":["6675558471377203772"],"messageType":2,"moduleName":"89df7546fb42447db42d44e1c25a813c","content":"您已经被设置为项目负责人角色","url":""}
      let duration = 30000
      if (process.env.NODE_ENV === 'development') {
        duration = 5000
      }
      if ([2, 4, 5, 6, 7].includes(messageType)) {
        this.$notify({
          group: 'foo',
          type: messageType,
          title: content,
          duration
        })
      } else if (authorAccount && fileName) {
        this.$notify({
          group: 'foo',
          type: messageType,
          title: `收到 ${authorAccount} 分享 ${fileName} ${hasMarkup ? '工程有批注' : ''}，请打开消息中心查看。`,
          duration
        })
      }
      this.showAnimate = false
      clearTimeout(this.receiveTimer)
      this.receiveTimer = setTimeout(() => {
        this.showAnimate = true
        this.refreshHeaderIndex++
        this.newMessage = true
        setTimeout(() => {
          this.showAnimate = false
        }, 3000)
      }, duration)
    },
    ...mapMutations({
      setPersonalTypeFilter: 'spacefilter/SET_PERSONAL_FILTER',
      setEnterproseTypeFilter: 'spacefilter/SET_ENTERPRISE_FILTER',
      setUserInfo: 'user/SET_USERINFO',
      setUserMobile: 'user/SET_USER_MOBILE',
      setWorkspace: 'space/SET_WORKSPACE',
      setMenuData: 'sidebarData/SET_MENU_DATA',
      setActive: 'sidebarData/SET_ACTIVE'
    }),
    handleCloseMessage (props) {
      props.close()
      // this.showAnimate = true;
      // this.refreshHeaderIndex++;
      // this.newMessage = true;
      // setTimeout(() => {
      //   this.showAnimate = false
      // }, 3000)
    },
    // 1.0 初始化 页面
    initPage () {
      Bus.$on('showAllNotice', (file) => {
        setTimeout(() => {
          this.showAllNotice()
        }, 100)
      })
      this.computedContentHeight()
      this.resizeHandle.resize(() => {
        this.computedContentHeight()
      })
      // 预加载 未购买套餐提示弹窗图片
      this.loadImg(this.noUsablePackageImg)
      if (getCookie('PCFLAG')) {
        this.setUserInfo()
        delCookie('PCFLAG')
      }
      // 检查会话是否超时(登录是否失效)
      this.checkSession(true) // mixins/index.js
      this.getWorkspaceList()
      if (this.isPreviewPage || this.headerWhite) {
        // 预览页面 or header 是白底的 嵌入的 企业云产品相关页面
        this.findPreviewName()
        this.hashChangeHandle()
      } else {
        // 其他页面
        /** * 注册事件相关 start ****/
        // 每执行完一个上传任务时 手动获取下 上传历史 提示 小红点
        // Bus.$on('uploadOne', (file) => {
        //   setTimeout(() => {
        //     this.refreshHotpoint('afterUpload') // mixins/index.js
        //   }, 500)
        // })
        const eventList = [
          'drop',
          'dragenter',
          'dragover'
        ]
        const eventObj = {}
        eventList.forEach((name) => {
          eventObj[name] = null
        })
        on(document, 'drop', eventObj.drop = function (e) {
          e.preventDefault()
          e.stopPropagation()
          return false
        })
        on(document, 'dragenter', eventObj.dragenter = function (e) {
          e.preventDefault()
          e.stopPropagation()
          return false
        })
        on(document, 'dragover', eventObj.dragover = function (e) {
          e.preventDefault()
          e.stopPropagation()
          return false
        })
        /** * 注册事件相关 end ****/
        // this.refreshHotpoint('init')
        // 初始化菜单 已在 store 里面获取
        // this.checkPasswordMobile()
        // 消息推送
        this.disconnect() // 断开之前的链接
        if (this.user.gldUserId) {
          this.initWebSocket() // 创建一个新的链接
        }
        // 动态添加自定义字体样式
        let noticeButton = document.getElementById('notice_button')
        if (noticeButton) {
          let pos = noticeButton.getBoundingClientRect()
          let right = (document.body.clientWidth || document.documentElement.clientWidth) - pos.left - pos.width
          let style = document.createElement('style')
          style.type = 'text/css'
          style.innerText = `
            @keyframes scaleTo {
              0% {
                opacity: 1;
                border-radius: 0%;
                transform: scale(1);
              }
              100% {
                opacity: 0.1;
                border-radius: 50%;
                transform: scale(0);
                top: 10px;
                right: ${right}px;
              }
            }
          `
          document.getElementsByTagName('head')[0].appendChild(style)
        }
      }

    },
    // 1.1 初始化 内容区域高度
    computedContentHeight () {
      const windowHeight = document.body ? document.body.clientHeight : (document.documentElement ? document.documentElement.clientHeight : 0)
      // this.contentHeight = Math.max(400, windowHeight - 56)
      this.contentHeight = windowHeight - 56
    },
    getPermission (){
      const orgId = this.user.orgId || getCookie('orgId')
      permissionService.getMoudleAuthList(orgId).then(res => {
        if (+res.code === 200 && res.data) {
          sessionStorage.setItem('ModuleAuthList', res.data)
          const ROLE_QYDB_GX = this.hasPermissonList('zjy_module_gxzlk_gxzl_manage')
          this.$store.commit('user/SET_PERMISSION', ROLE_QYDB_GX, {root: true})
        }
      }).catch((err) => {
        console.error('获取模块权限失败', err)
      })
    },
    getTenantInfo (){
      permissionService.getTenantInfo(this.user.tenantId).then(res => {
        if (+res.code === 200 && res.data) {
          sessionStorage.setItem('TenantInfo', res.data)
        }
      })
    },
    // 1.2 获取登录用户 空间列表
    getWorkspaceList () {
      if (this.isPreviewPage) return
      spaceService.getWorkspaceList().then(data => {
        if (+data.code === 200) {
          const arr = data.data || []
          const workspace = {}
          arr.forEach(item => {
            if (item.type === 1){
              // 1=个人空间/员工空间,
              setCookie('personalWorkspaceIdValue', item.id)
            }
            if (item.type === 2){
              // ,2=共享空间
              setCookie('enterpriseWorkspaceIdValue', item.id)
            }
            if (item.type === 3){
              // 3=项目空间
              setCookie('projectWorkspaceIdValue', item.id)
            }
            workspace[item.type] = item.id
          })
          this.setWorkspace(workspace)
        }
      })
    },
    // 1.3 获取登录用户 空间容量使用情况
    getWorkspaceById ({id, type}) {
      spaceService.getWorkspaceById({workspaceId: id}).then(data => {
        let obj = {
          'workspaceId': 0,
          'totalCapacity': 0, // 总容量
          'usedCapacity': 0, // 已使用容量
          'residualCapacity': 0, // 剩余容量
          'allOtherUsedCapacity': 0
        }
        if (+data.code === 200) {
          Object.assign(obj, data.data || {})
          // 企业员工 空间使用量 单位为G
          let unit = 1024 * 1024 * 1024
          // if (+type === 1 && this.user.userType === 2) {
          //   // 个人账号 空间使用量 单位为M
          //   unit = 1024 * 1024
          // }
          let {totalCapacity, usedCapacity, allOtherUsedCapacity} = obj
          totalCapacity = Math.abs(+totalCapacity / unit).toFixed(2)
          // console.log(+usedCapacity / unit)
          // console.log(type)
          // usedCapacity = (+usedCapacity / unit)
          //   .toFixed(2)
          //   .replace(/[0]+$/, "")
          //   .replace(/\.$/, "");
          // usedCapacity = parseFloat(usedCapacity);
          usedCapacity = (+usedCapacity / unit)
          allOtherUsedCapacity = (+allOtherUsedCapacity / unit)
          if (usedCapacity < 0.01) {
            usedCapacity = 0
          } else {
            usedCapacity = usedCapacity.toFixed(2)
          }
          if (allOtherUsedCapacity < 0.01) {
            allOtherUsedCapacity = 0
          } else {
            allOtherUsedCapacity = allOtherUsedCapacity.toFixed(2)
          }
          switch (+type) {
            case 1: // 个人空间 使用情况
              Object.assign(this.capacity.personal, {
                total: totalCapacity || 0,
                used: usedCapacity || 0,
                staffUsed: allOtherUsedCapacity || 0
              })
              this.$nextTick(() => {
                this.refreshHeaderIndex++
              })
              break
            case 2: // 企业空间 使用情况
              Object.assign(this.capacity.company, {
                total: totalCapacity || 0,
                used: usedCapacity || 0
              })
              this.$nextTick(() => {
                this.refreshHeaderIndex++
              })
              break
            default:
          }
        }
      })
    },
    // 1.3.1 获取企业空间占用情况
    fetchCompanyStorage () {
      console.log('获取企业空间占用情况')
      if (this.workspace && this.workspace[2]) {
        this.getWorkspaceById({
          id: this.workspace[2],
          type: 2
        })
      }
    },
    // 1.3.2  获取员工空间占用情况
    fetchPersonalStorage () {
      console.log('获取员工空间占用情况')
      if (this.workspace && this.workspace[1]) {
        this.getWorkspaceById({
          id: this.workspace[1],
          type: 1
        })
      }
    },
    // 1.4 获取 预览文件名称
    findPreviewName () {
      let name = ''
      const params = getParams(window.location.href) || {}
      name = params.fileName || params.title || ''
      if (params.previewFileName) {
        name = getCookie(params.previewFileName) || ''
      }
      this.previewName = decodeURIComponent(name)
    },
    // 1.4.1 深度预览 请求参数变化时 修改 header 文件名称
    hashChangeHandle () {
      if (/\/preview\/(gbq5|gsc5|gpv5|gsh5|gpb5|gbq6|gsc6|gpv6|gsh6|gpb6|gbq7|gsc7|gpv7|gsh7|gpb7)$/i.test(this.$route.path) || this.headerWhite) {
        //  && ((typeof document.documentMode==='undefined') || document.documentMode==8)
        if (('onhashchange' in window)) {
          // 浏览器支持onhashchange事件
          window.onhashchange = () => {
            this.findPreviewName()
            this.setConfigState({previewFileChange: true})
          }
        }
      }
    },
    // 1.5 检查隐私协议授权情况
    checkPrivacy () {
      // !this.isCostCloud 如：一冶项目
      if (this.isPreviewPage || this.boardPage || !this.isCostCloud) return
      sessionStorage.setItem('privacyShow', this.user.gldUserId)
      api.user.checkPrivacy().then(data => {
        console.log('------ checkPrivacy ------')
        console.log(data)
        if (+data.code === 200) {
          if (!data.data) {
            let aaa = this.$showPrivacy()
            // let _self = this
            aaa.$watch('isShow', (newVal, oldVal) => {
              this.privacyShow = newVal
              this.getUnreadShareMsg()
              // 检测新手引导
              // _self.startGuid()
            })
          } else {
            this.privacyShow = false
            this.getUnreadShareMsg()
            // 添加用户账号
            // eslint-disable-next-line no-undef
            ga('set', 'userId', getCookie('ZJYACCOUNT'))
            // 检测新手引导
            // this.startGuid()
          }
        }
      }).catch((_) => {
        this.getUnreadShareMsg()
        // 容错措施，当出现错误时，按未同意隐私处理
        const zjyUserInfo = JSON.parse(getCookie('ZJYUSERINFO'))
        if (zjyUserInfo && zjyUserInfo.gldUserId) {
          // eslint-disable-next-line no-undef
          ga('set', 'userId', zjyUserInfo.gldUserId)
        }
      })
    },
    // 1.5.1 检查密保手机绑定情况
    checkPasswordMobile () {
      // if ((this.user && this.user.passwordMobile) || (this.userInStore && this.userInStore.passwordMobile)) {
      //   if (sessionStorage.getItem('privacyShow') !== this.user.gldUserId) {
      //     this.checkPrivacy()
      //   }
      // } else {
      //   this.bindMobilePhone()
      // }
      if ((this.user && this.user.passwordMobile) || (this.userInStore && this.userInStore.passwordMobile)) {
        if (sessionStorage.getItem('privacyShow') !== this.user.gldUserId) {
          this.checkPrivacy()
        }
      } else if (!isEmptyObject(this.user) || !isEmptyObject(this.userInStore)) {
        this.bindMobilePhone()
      }
    },
    // 1.5.2 引导密保手机弹框
    bindMobilePhone () {
      this.showBindMobilePhone = true
    },
    // 1.5.3 提交密保手机表单
    postPasswordMobile (mobile) {
      this.showBindMobilePhone = false
      this.$message({
        message: '账号信息完善成功，使用关联的手机号即可快捷登录',
        customClass: 'width-394',
        type: 'success'
      })
      // 记录已经绑定的手机
      this.setUserMobile(mobile)
      let userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
      userinfo.passwordMobile = mobile
      setCookie('ZJYUSERINFO', JSON.stringify(userinfo))
      if (sessionStorage.getItem('privacyShow') !== this.user.gldUserId) {
        this.checkPrivacy()
      }
    },
    // 1.6 检查是否存在未读分享信息
    getUnreadShareMsg () {
      MessageService.getHasShareMessages().then((res) => {
        if (+res.code === 200 && res.data) {
          this.showLeftMessage = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 1.6.1 点击页面右侧消息列表 显示所有消息 弹窗
    showAllNotice () {
      this.showLeftMessage = false
      this.showMainMessage = true
    },
    // 1.6.2 关闭所有消息 弹窗
    closeAllNotice (routePath = '', params = {}) {
      this.showLeftMessage = false
      this.showMainMessage = false
      // Bus.$emit('closeAllNotice')
      if (routePath === 'ugc') {
        this.showComplain = true
        this.complainfileInfo = params
      } else if (routePath && this.$route.path !== routePath) {
        this.$router.push({
          path: routePath
        })
      }
    },
    // 2. 页头操作
    headerClickFun (obj) {
      if (obj && obj.type) {
        switch (obj.type) {
          // case 'readMessage': // 消息小铃铛 点击
          //   this.sentLog(100110002)
          //   this.setUploadMessage('0')
          //   this.resetHotpoint('Message')
          //   this.showLeftMessage = true
          //   break
          case 'downloadHelpDoc': // 下载帮助文档 点击
            this.sentLog(100110022)
            const url = api.common.downloadHelpDoc()
            window.common.downloadFile(url)
            break
          case 'loginAsAdmin': // 退出到登录页面 并将管理员名称反显到 用户名输入框 ADMIN_COUNT_HIT
            this.sentLog(100110001)
            this.accountLogout(this.user.adminAccount)
            break
          case 'logout': // 退出 点击
            this.sentLog(100110025)
            this.accountLogout()
            break
          case 'open': // 新窗口打开页面 如: 跳转到 用户中心、安全中心
            switch (obj.action) {
              case 'userCenter':
                this.sentLog(100110019)
                break
              case 'securityCenter':
                this.sentLog(100110020)
                break
              default:
            }
            break
          case 'jumping': // 系统内跳转
            if (obj.action) {
              let toPath = ''
              switch (obj.action) {
                case 'productCenter':
                  this.sentLog(100110021)
                  toPath = '/production'
                  break
                case 'Upload':
                  this.sentLog(100110023)
                  toPath = '/upload/done/project'
                  if (+this.newUpload === 2) {
                    toPath = '/upload/done/list'
                  }
                  if (+this.newUpload === 3) {
                    toPath = '/upload/done/group'
                  }
                  this.setLeftMenus({path: toPath})
                  break
                case 'Feedback':
                  this.sentLog(100110024)
                  toPath = '/feedback/add'
                  this.setLeftMenus({path: toPath})
                  break
                default:
              }
              if (!toPath) return
              if (this.hasUploadTask) {
                // 必须要跳转到 当前域名以外的其他地址前
                // 才会触发 window.onbeforeunload (若正在执行上传任务时，浏览器弹出确认框'系统可能不会保存您所做的更改。') App.vue
                this.singleLogin(this.hrefPrefix + toPath)
              } else {
                this.$router.push({path: toPath})
              }
            }
            break
          case 'import': // 导入个人账号
            this.sentLog(100113053)
            this.showImportDialog = true
            break
          case 'invite': // 邀请员工加入企业
            this.$showInvite()
            break
          default:
        }
      }
    },
    // 关闭UGC弹窗
    closeComplainDialog (success = false) {
      this.showComplain = false
      this.complainFileId = null
      if (success) {
        this.showComplainSuccess = true
      }
    },
    // 2.1 清除小红点
    resetHotpoint (type) {
      if (type === 'Message') {
        api.common.deleteHotpointMessage().then(data => {
          if (+data.code === 200) {
            this.newMessage = false
          }
        })
      } else if (type === 'Feedback') {
        api.common.deleteHotpointFeedback().then(data => {
          if (+data.code === 200) {
            this.newFeedback = false
          }
        })
      }
    },
    // 1.7 弹出 当前用户已失效，请重新登录 提示
    showSessionTimeout () {
      console.log('-------------')
      console.log('=============')
      this.checkSession()
      this.refreshHotpoint()
      this.hideAllDialog(() => {
        if (this.boardPage) {
          return
        }
        setTimeout(() => {
          // 失效逻辑根据是否被frames嵌套进行分发处理
          this.logicDistributeWithFrames(() => {
            this.parentPostMessage({
              type: 3,
              data: {
                invalidToken: true
              }
            })
          }, () => {
            // this.$confirm({
            //   boxId: 'sessionInvalid',
            //   message: '当前用户已失效，请重新登录',
            //   noCancelBtn: true,
            //   submit: () => {
            //     // 重新登录要清空session storage信息
            //     sessionStorage.removeItem('privacyShow')
            //     sessionStorage.removeItem('vuex')
            //     sessionStorage.removeItem('gccsToken')
            //     delCookie('canVisitGray')
            //     sessionStorage.removeItem('tempRole')
            //     this.setConfigState({sessionAlertShow: false})
            //   }
            // })
          })
        }, 500)
      })
    },
    // 1.8 左侧菜单栏 展开/收起
    foldMenu (value) {
      this.menu.fold = value
    }
  },
  watch: {
    // 1. 收到信的上传历史消息
    uploadMessage: function (val) {
      // const list = this.uploadMessage.split(',')
      const list = val.split(',')
      this.newUpload = +list[0] || 0
      // this.newMessage = Boolean(+list[0] || 0)
    },
    // 2. 监听 router 变化
    $route (to, from) {
      Bus.$emit('leftMenuTips')
      let toVal = to.path
      let fromVal = from.path
      let fromObj = Object.assign({}, from)
      // 判断是不是分享页
      if (to.path.indexOf('/share/') === 0) {
        this.mainPage = false
      } else {
        this.mainPage = true
      }
      // 判断路径 渲染左侧 菜单 、储存返回时路径
      if (toVal !== '/home' &&
          ((JSON.stringify(this.uploadhistory).indexOf(toVal) > -1 &&
            JSON.stringify(this.uploadhistory).indexOf(fromVal) === -1 &&
            JSON.stringify(this.feedback).indexOf(fromVal) === -1) ||
            (JSON.stringify(this.feedback).indexOf(toVal) > -1 &&
              JSON.stringify(this.feedback).indexOf(fromVal) === -1 &&
              JSON.stringify(this.uploadhistory).indexOf(fromVal) === -1
            ))) {
        this.setActive(fromObj)
      }
      if (JSON.stringify(this.uploadhistory).indexOf(toVal) > -1 &&
          toVal !== '/home/index') {
        // this.sideBarData = this.uploadhistory
        this.$set(this.menu, 'list', this.uploadhistory)
      } else if (JSON.stringify(this.feedback).indexOf(toVal) > -1 &&
          toVal !== '/home/index') {
        // this.sideBarData = this.feedback
        this.$set(this.menu, 'list', this.feedback)
      } else {
        // this.sideBarData = this.sidebarData
        this.$set(this.menu, 'list', this.sidebarData)
      }
    },
    // 3. 登录的用户信息已就绪
    // userInfoReady: function  () {
    //   this.initMenu()
    // },
    // 4. 没有购买套餐 却执行了需要购买套餐的操作 弹出 购买套餐提示
    noUsablePackageAlertShow: function (val) {
      if (val) {
        this.$confirm({
          type: 'noUsablePackage',
          imageSrc: this.noUsablePackageImg,
          submit: (data) => {
            this.setConfigState({noUsablePackageAlertShow: false})
            this.$router.push({
              path: '/vip'
            })
          },
          submitText: '立即购买',
          cancel: () => {
            this.setConfigState({noUsablePackageAlertShow: false})
          },
          noCancelBtn: true
        })
      }
    },
    // 5. session 超时处理
    sessionAlertIndex: function () {
      const box = document.getElementById('alert_sessionInvalid')
      const toLoginPage = (fromPath) => {
        let hrefPrefix = this.hrefPrefix
        hrefPrefix = hrefPrefix.replace('-gray', '')
        hrefPrefix = hrefPrefix.replace('zjyrefactor', 'zjytest')
        hrefPrefix += '/#/index?willLogin=true'
        if (fromPath) {
          hrefPrefix += '&fromPath=' + fromPath
        }
        // session 删除 canVisitGray 将会用作 灰度相关地址是否需要重定向到 非灰度的凭据
        delCookie('canVisitGray')
        // 跳转到用户中心 然后重定向回来 解决 前端发版后 之前版本的源文件 被删除了  this.$router.push(obj) 请求之前的文件404 报错 不能跳转到登录页的问题
        window.location.href = 'https://me.glodon.com/api/logout?return_to=' + encodeURIComponent(hrefPrefix)
        // https://me.glodon.com/api/logout?return_to=
        // https://account.glodon.com/logout?return_to=https%3a%2f%2fme.glodon.com%2fapi%2flogout%3freturn_to%3dhttp%253A%252F%252Flocalhost%253A8082%252F%2523%252Findex%253FwillLogin%253Dtrue
        // let href = window.location.origin
        // if (/-gray/.test(href) || /zjyrefactor/.test(href)) {
        //   href = href.replace('-gray', '')
        //   href = href.replace('zjyrefactor', 'zjytest')
        //   if (fromPath) {
        //     href += '/#/index?fromPath=' + fromPath
        //   }
        //   window.location.href = href
        // } else {
        //   const obj = {path: '/index'}
        //   if (fromPath) {
        //     obj.query = {fromPath}
        //   }
        //   this.$router.push(obj)
        // }
      }
      if (this.sessionAlertShow && !box) {
        if (this.isPreviewPage || !this.mainPage) {
          // 预览页 未登录时 跳转到登录页
          let fromPath = encodeURIComponent(this.$route.fullPath)
          if (previewShareGtj(this)) {
            // 如果是预览分享的 GTJ 文件
            // alert(previewShareGtj(this))
            if (this.isIEBrowser()) {
              return
            } else {
              fromPath = encodeURIComponent(previewShareGtj(this))
            }
          }
          toLoginPage(fromPath)
        } else {
          this.showSessionTimeout()
        }
      } else if (!this.sessionAlertShow) {
        console.log('跳转到登录页')
        try {
          toLoginPage()
        } catch (e) {
          console.log(e)
          let href = window.location.href
          const hrefPrefix = href.substring(0, href.indexOf(this.$route.path))
          window.location.href = hrefPrefix + '/index'
        }
      }
    },
    // 6. 提示弹窗中 "我是管理员" 点击时触发
    toLoginAsAdmin: function () {
      this.accountLogout(this.user.adminAccount)
    },
    // 7. 触发初始化页面
    triggerInitPageIndex: function () {
      this.initPage()
    },
    // 8. 菜单变动时判断
    menuList: function (val) {
      const getItemByWindowName = (menu) => {
        menu.map((child) => {
          if (child.menuName === '量价规则库' && !obj.jl) {
            obj.jl = child
          } else {

          }
          if (child.menuName === '组价数据库' && !obj.zj) {
            obj.zj = child
          }
          if (child.children && child.children.length) {
            getItemByWindowName(child.children)
          }
        })
      }
      let obj = {}
      getItemByWindowName(val)
      console.log(this.$route.path)
      console.log(111)
      if (this.$route.query.title === '组价数据库' || this.$route.path.indexOf('applications/combination/manage') > -1 || this.$route.path.indexOf('database%2Fbasis') > -1) {

        this.switchModule(obj.zj, true, true)

      } else if (this.$route.query.title === '量价规则库' || this.$route.path.indexOf('gtjrule-ui') > -1) {
        this.switchModule(obj.jl, true, true)
      }
    }
  },
  components: {
    HeaderGeneral,
    MainMessage,
    LeftMessage,
    ImportPersonalAccount,
    MenuLeft,
    BindMobilePhone,
    Complain,
    ComplainSuccess
  }
}
</script>
